import { styled, Typography } from '@mui/material';
import { Modal } from '../../../../components/Modal';
import { yearMapping, yearType } from '../../constants';

function DisclaimerModal(props: { isOpen: boolean; close: () => void; selectedPromo: yearType }) {
    return (
        <Modal
            isOpen={props.isOpen}
            close={props.close}
            onConfirm={props.close}
            size="small"
            title="Récapitulatif d'inscription"
            confirmButtonLabel="J'ai compris"
        >
            <TextContainer>
                <p>
                    Votre formulaire d'inscription en {yearMapping[props.selectedPromo].label} a
                    bien été envoyé à l'administration.
                </p>
                <p>Vous pouvez sauvegarder le récapitulatif sur cette page.</p>
            </TextContainer>
        </Modal>
    );
}

const TextContainer = styled(Typography)(({ theme }) => ({}));

export { DisclaimerModal };
